import GDriveFile from './gdrive-file'

export default GDriveFile
